import React from "react";

const EmptyComponent = () => {
  return <div></div>;
};

export default EmptyComponent;
